import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const OnsiteEditsTestIconFilled = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      sx={{ width: props.width ?? "27px", height: props.height ?? "16px" }}
    >
      <svg
        viewBox="0 0 27 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_13065_31617)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.4943 0H25.5057C26.3261 0 27 0.689784 27 1.52952V10.5267C27 11.3664 26.3261 12.0562 25.5057 12.0562H1.4943C0.673901 12.0562 0 11.3664 0 10.5267V1.52952C0 0.689784 0.673901 0 1.4943 0Z"
            fill={props.fill ?? "#2962FF"}
          />
          <path
            d="M15.7629 3.94336H14.3711C14.1367 3.94336 13.873 4.07832 13.873 4.4682V7.28731C13.873 7.51224 14.0635 7.70718 14.2832 7.70718C14.503 7.70718 14.6934 7.51224 14.6934 7.28731V6.40259H15.7629C16.0706 6.40259 16.3343 6.23764 16.4954 5.93774C16.6126 5.7278 16.6712 5.45789 16.6712 5.17298C16.6712 4.4532 16.305 3.94336 15.7629 3.94336ZM15.7629 5.56285H14.6934V4.7831H15.7629C15.7922 4.81309 15.8655 4.94805 15.8655 5.17298C15.8655 5.3979 15.7922 5.53286 15.7629 5.56285Z"
            fill="#F8F6F6"
          />
          <path
            d="M5.31765 3.94336C5.0979 3.94336 4.90745 4.1233 4.90745 4.36323V5.4129H3.6329V4.36323C3.6329 4.1383 3.4571 3.94336 3.2227 3.94336C2.9883 3.94336 2.8125 4.1233 2.8125 4.36323V7.28731C2.8125 7.51224 2.9883 7.70718 3.2227 7.70718C3.4571 7.70718 3.6329 7.52724 3.6329 7.28731V6.23764H4.90745V7.28731C4.90745 7.51224 5.08325 7.70718 5.31765 7.70718C5.55206 7.70718 5.72786 7.52724 5.72786 7.28731V4.36323C5.72786 4.1383 5.55206 3.94336 5.31765 3.94336Z"
            fill="#F8F6F6"
          />
          <path
            d="M9.14089 3.94336H7.06059C6.84084 3.94336 6.65039 4.1233 6.65039 4.36323C6.65039 4.60315 6.82619 4.7831 7.06059 4.7831H7.69054V7.30231C7.69054 7.52724 7.86634 7.72218 8.10074 7.72218C8.33514 7.72218 8.51094 7.54223 8.51094 7.30231V4.7831H9.14089C9.36065 4.7831 9.5511 4.60315 9.5511 4.36323C9.5511 4.1383 9.3753 3.94336 9.14089 3.94336Z"
            fill="#F8F6F6"
          />
          <path
            d="M12.5999 3.94336H10.5196C10.2998 3.94336 10.1094 4.1233 10.1094 4.36323C10.1094 4.60315 10.2852 4.7831 10.5196 4.7831H11.1495V7.30231C11.1495 7.52724 11.3253 7.72218 11.5597 7.72218C11.7941 7.72218 11.9699 7.54223 11.9699 7.30231V4.7831H12.5999C12.8196 4.7831 13.0101 4.60315 13.0101 4.36323C13.0101 4.1383 12.8343 3.94336 12.5999 3.94336Z"
            fill="#F8F6F6"
          />
          <path
            d="M18.5176 7.00282C18.2979 7.00282 18.1074 6.82288 18.1074 6.58295C18.1074 6.34303 18.2832 6.16309 18.5176 6.16309C18.752 6.16309 18.9278 6.34303 18.9278 6.58295C18.9278 6.82288 18.752 7.00282 18.5176 7.00282Z"
            fill="#F8F6F6"
          />
          <path
            d="M18.5176 5.26357C18.2979 5.26357 18.1074 5.08362 18.1074 4.8437C18.1074 4.60377 18.2832 4.42383 18.5176 4.42383C18.752 4.42383 18.9278 4.60377 18.9278 4.8437C18.9278 5.08362 18.752 5.26357 18.5176 5.26357Z"
            fill="#F8F6F6"
          />
          <path
            d="M20.5975 7.70768C20.5975 7.70768 20.4803 7.70768 20.4363 7.67769C20.2312 7.58772 20.1433 7.3328 20.2312 7.12286L21.4911 4.19878C21.579 3.98884 21.8281 3.89887 22.0332 3.98884C22.2383 4.07881 22.3262 4.33373 22.2383 4.54367L20.9784 7.46775C20.9051 7.61771 20.7586 7.72268 20.6121 7.72268L20.5975 7.70768Z"
            fill="#F8F6F6"
          />
          <path
            d="M22.7068 7.70768C22.7068 7.70768 22.5896 7.70768 22.5457 7.67769C22.3406 7.58772 22.2527 7.3328 22.3406 7.12286L23.6005 4.19878C23.6884 3.98884 23.9374 3.89887 24.1425 3.98884C24.3476 4.07881 24.4355 4.33373 24.3476 4.54367L23.0877 7.46775C23.0145 7.61771 22.868 7.72268 22.7215 7.72268L22.7068 7.70768Z"
            fill="#F8F6F6"
          />
          <path
            d="M19.7924 15.7755L17.4923 13.2713L16.628 14.066C16.628 14.066 16.4522 14.096 16.4082 13.9761L16.0859 9.62743C16.0859 9.62743 16.0859 9.53746 16.0859 9.52246C16.0859 9.52246 16.1299 9.52246 16.1885 9.52246L20.3784 10.2872C20.4956 10.3322 20.5102 10.4522 20.437 10.5122L19.5726 11.3069L21.902 13.8111C21.902 13.8111 21.9313 13.9161 21.8873 13.9761L20.9204 14.8758L19.9535 15.7755C19.9535 15.7755 19.8363 15.8355 19.7924 15.7755Z"
            fill="white"
            stroke={props.fill ?? "#2962FF"}
            strokeWidth="0.25"
            strokeMiterlimit="10"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};
